<template>
    <main-layout>
        <div class="container azSize has-text-centered">
            <!-- <div class="pageTitle isPoppins"><b>Videos</b></div> -->
            <div class="top20 is-size-2 isPoppins has-text-dark  underline  has-text-centered kirvy">Videos</div>

             <div class="has-text-centered top60">
                <!-- <img src="https://content.jwplatform.com/thumbs/O8J8HzLF-1920.jpg" width="250">&nbsp;&nbsp;
                <img src="https://content.jwplatform.com/thumbs/WUIYAZp9-1920.jpg"  width="250"> -->
                    
                <div class="is-inline-block videoTrig has-text-right" @click="openVideo('https://content.jwplatform.com/videos/O8J8HzLF-ZwDaX2fG.mp4')">
                    <i class="fa fa-play-circle fa-4x has-text-primary"></i><br>
                    <span class="is-size-5 has-text-primary videoLabel" style="z-index: 5"><b>What is Slink?</b></span>
                </div>
                
                    <div class="is-inline-block videoTrig2 has-text-right" @click="openVideo('https://content.jwplatform.com/videos/WUIYAZp9-ZwDaX2fG.mp4')">
                    <i class="fa fa-play-circle fa-4x has-text-primary"></i><br>
                    <span class="is-size-5 has-text-primary videoLabel" style="z-index: 5"><b>A Use Case</b></span>
                </div>
            </div>

        <div class="has-text-centered top60 is-size-3 ">
           <div class="alterHeading has-background-primary"> 
               <b class="isPoppins ">No one will ever forget how to find you!</b>
            </div><br>
             <img class="top20" src="@/assets/img/ownyourwordsyellow.png" width="200"/>
            
        </div>
        <br><br>

       

         
        </div>

         <video1 v-if="videoOpen"></video1>
    </main-layout>
</template>

<script>
import Video1 from '../components/Video1.vue'

export default {
    components: {Video1},
    data: function(){
        return {
            videoOpen: false
        }
    },

    methods: {
        openVideo: function(vid){
            window.scrollTo(0,0)
            this.vid = vid //  
            this.videoOpen = true
        },

        closeVideo: function(){
        this.videoOpen = false
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/pages/Videos.vue